import { withPrefix } from 'gatsby'

export const prefixUrlIfRelative = (url: string) => {
  if (!/^https?:\/\//i.test(url)) {
    return withPrefix(url)
  }
  return url
}
